export default "__VITE_ASSET__eWdd2Enm__"